export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6787.07566309.jpg";